const validationEn = {
    "required": "This field is required",
    "min_value": "The value cannot be less than {{value}}",
    "max_value": "The value cannot be greater than {{value}}",
    "date_before_today": "The date cannot be before today",
    "date_order": "The start time must be before the end time",
    "event_duration_too_long": "The event duration cannot be 24 hours or more (max. 23:59)",
    "event_id_taken": "An event with this ID already exists",
    "invalid_phone": "Invalid phone number",
    "table_removed_for_overlap": "Tables were removed from the reservation due to overlapping with existing reservations: {{tables}}",
    "not_enough_seats": "The number of guests ({{guests}}) exceeds the number of available seats at the tables: {{seats}}.",
    "invalid_email_for_guest": "The guest does not have a valid email address",
    "invalid_url": "Invalid URL",
    "invalid_email": "Invalid email address",
}

export default validationEn;